<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
  // beforeCreate(){
  //    console.log(this.$route)
  // }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/App.vue